import React from 'react';
import Select from '../Select/Select';
import { CAR_DOCUMENT_TYPES } from '../../constants';

const SelectCarDocumentType = ({ ...props }) => {
  return <Select options={CAR_DOCUMENT_TYPES} label={'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectCarDocumentType;
